import { setRangeMax } from './helpers';

export const setAreaMax = setRangeMax('total_area');
